import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { concatMap, finalize, takeUntil } from 'rxjs/operators';
import { GroupsService } from '../../../../groups/groups.service';
import { GroupDetail } from '../../../../groups/models/group-detail.model';
import { AuthService } from '../../../../shared/services/auth.service';

@Component({
  templateUrl: './access-list-dialog.component.html',
  styleUrls: ['./access-list-dialog.component.scss']
})
export class AccessListDialogComponent implements OnInit {
  loading: boolean = false;
  group: GroupDetail;
  subGroups: GroupDetail[] = [];
  selectedGroups: string[] = []
  subgroupsAccessList: { [key: string]: string[] } = {};
  tempSubgroupsAccessList: { [key: string]: string[] } = {};
  public profile: boolean = false;
  constructor(
    private authService: AuthService,
    private groupsService: GroupsService,
    private dialogRef: MatDialogRef<AccessListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.selectedGroups = [...this.data.selectedGroups];
  }

  ngOnInit(): void {
    this._loadSubGroups();
  }

  private _loadSubGroups() {
    this.loading = true;
    console.log(this.data?.slide);
    this.groupsService
      .getGroupDetailsPublic(this.authService.idenediGroupId)
      .pipe(concatMap(group => {
        this.group = group;
        return this.groupsService
          .fetchSubGroups(this.authService.idenediGroupId)
      }), finalize(() => { this.loading = false })).subscribe(subGroups => {
        const anonymousGroup = new GroupDetail(this.group);
        anonymousGroup.Idenedi = 'anonymous',
          anonymousGroup.Profile.FirstName = "Non Members";
        const makeAdmin = new GroupDetail(this.group);
        makeAdmin.Idenedi = 'admins',
          makeAdmin.Profile.FirstName = "Admins";

        const slide = this.data?.slide;
        if (slide && slide.hasOwnProperty('AlternateSlideVisibleBy') && slide.AlternateSlideVisibleBy == null) {
          this.subGroups = [anonymousGroup, this.group, makeAdmin, ...subGroups];
        } else {
          if (this.data?.subGroupsOnly) {
            this.subGroups = [anonymousGroup, makeAdmin, ...subGroups];
          } else {
            this.subGroups = [anonymousGroup, makeAdmin, this.group, ...subGroups];
          }
        }
      })
  }

  isSubGroupSelected(groupIdenedi: string): boolean {
    const slide = this.data?.slide;
    if (slide && slide.hasOwnProperty('AlternateSlideVisibleBy') && slide.AlternateSlideVisibleBy == null) {
      return this.selectedGroups.includes(groupIdenedi);
    } else {
      return this.selectedGroups.includes(groupIdenedi);
    }
  }

  onSubGroupsCheckboxChanged($event: MatCheckboxChange, group: GroupDetail) {
    const subgroupId = $event.source.value;

    if (!this.subgroupsAccessList[subgroupId]) {
      this.subgroupsAccessList[subgroupId] = [];
    }
    if ($event.checked) {
      this.selectedGroups = [...this.selectedGroups, subgroupId];
      // this.subgroupsAccessList[subgroupId].push(this.selectedListId);

      // if (this.subgroupsAccessList['0']) {
      //   if (this.subgroupsAccessList['0'].length) {
      //     this.subgroupsAccessList['0'] = this.subgroupsAccessList['0'].filter(aclId => aclId != this.selectedListId);
      //   }
      // }
    } else {
      this.selectedGroups = this.selectedGroups.filter(sg => sg !== subgroupId);
      // this.subgroupsAccessList[subgroupId] = this.subgroupsAccessList[subgroupId].filter(item => item !== this.selectedListId);

      // let orgExists: boolean = Object.keys(this.subgroupsAccessList).flatMap(key => this.subgroupsAccessList[key]).some(orgId => orgId == this.selectedListId)
      // if (!orgExists) {
      //   if (!this.subgroupsAccessList['0']) {
      //     this.subgroupsAccessList['0'] = [];
      //   }
      //   this.subgroupsAccessList['0'].push(this.selectedListId)
      // }
    }
    // this._removeEmptyAccessLists();
  }
  selectedListId: string = '1'

  closeDialog() {
    this.dialogRef.close(this.selectedGroups);
  }

}
